import {useEffect, useState} from 'react';
import {useNavigation} from '@react-navigation/native';
import {DrawerNavigationProp} from '@react-navigation/drawer';
import {Components} from '@oneamerica/dxp-ui-components';
import responsiveStyle from './style';
import RouteConstants from '../../constants/RouteConstants';

interface NoStatementsAvailableProps {
  showModal: boolean;
  onClose?: () => void;
}

export const NoStatementsAvailable = ({
  showModal,
  onClose,
}: NoStatementsAvailableProps) => {
  const [showNoStatementsAvailable, setShowNoStatementsAvailable] =
    useState<boolean>(false);
  const navigation = useNavigation<DrawerNavigationProp<any>>();
  const styles = responsiveStyle();

  useEffect(() => {
    setShowNoStatementsAvailable(showModal);
  }, [showModal]);

  const navigateToContactUs = () => {
    setShowNoStatementsAvailable(false);
    navigation.navigate(RouteConstants.contactus);
  };

  const onCloseModal = () => {
    onClose?.();
  };

  const linkStyleContactUs = {
    style: styles.linkContactUs,
    linkStyle: styles.linkContactUs,
    linkHoverStyle: styles.linkContactUs,
    hoverStyle: styles.linkContactUsHover,
    focusStyle: styles.linkContactUsFocus,
  };

  return (
    <Components.DialogModal
      style={styles.smModalSize}
      backgroundColor="#F3F9FE"
      width={365}
      padding={20}
      visible={showNoStatementsAvailable}
      Header={
        <Components.Text style={styles.modalTitle}>
          Latest Statement not available
        </Components.Text>
      }
      onClose={onCloseModal}>
      <Components.Text className="grow-0 mt-[16px]">
        {'You do not have a latest statement on file.\n\n'}
        {
          'If you have any questions, please reference the Policy Services section on the '
        }
        <Components.Link
          onPress={navigateToContactUs}
          accessibilityLabel="Contact Us"
          accessibilityRole="button"
          {...linkStyleContactUs}>
          Contact Us
        </Components.Link>{' '}
        {'page.'}
      </Components.Text>
    </Components.DialogModal>
  );
};
